import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { MenuItem, } from '../../../index.js';
export const MenuItemCheckbox = forwardRef(({ as, children, checked, ...otherProps }, forwardedRef) => (_jsx(MenuItem, { as: as, role: "menuitemcheckbox", "aria-checked": checked, ref: forwardedRef, ...otherProps, children: children })));
